export const environment = {
  production: true,
  envName: "uat",
  applicationName: "Inmar.Healthcare.AuditPlus",
  applicationApplinkFeature: "AuditPlusUI",
  applicationDisplayName: "RX AUDIT MANAGEMENT",
  rootUrl: "http://uat-web-auditplus.healthcare.inmar.com",
  healthcareTopBar:
    'https://qa-web-auth.healthcare.inmar.com/Scripts/healthcare-topbar-v2.js',
  auth0: {
    domain: "ut-login.healthcare.inmar.com",
    clientId: "qPwLjxvwvY0sCXe4UYHfimLbqZV5Rl3k",
    refreshToken: true,
    scope: "openid profile email",
  },
  authZApiRoot: {
    url: "https://qa-api-authz.healthcare.inmar.com/v1.0",
    audience: "https://qa-api-authz.healthcare.inmar.com",
  },
  auditApiRoot: {
    url: "https://uat-api-auditplus.healthcare.inmar.com/v1.0/api",
    audience: "https://uat-api-auditplus.healthcare.inmar.com",
  },
  claimApiRoot: {
    url: "https://uat-api-claim.healthcare.inmar.com/v1.0/api",
    audience: "https://uat-api-claim.healthcare.inmar.com",
  },
  faxApiRoot: {
    url: "https://uat-api-fax.healthcare.inmar.com/v1.0/api",
    audience: "https://uat-api-fax.healthcare.inmar.com",
  },
  imageApiRoot: {
    url: "https://uat-api-imagerepository.healthcare.inmar.com/v1.0/api",
    audience: "https://uat-api-imagerepository.healthcare.inmar.com",
  },
  lookerAnalytics: {
    url: "https://stagingpfmanalytics.cloud.looker.com",
  },
  lookerAdminRoot: {
    url: "https://uat-api-lookeradmin.healthcare.inmar.com",
    audience: "https://uat-api-lookeradmin.healthcare.inmar.com",
  },
  helpDocName: "ManualClaimHelpV5.pdf",
  defaultListLimit: 9999, // API assumes 9999 is “get all” for drop lists
  appInsights: {
    instrumentationKey: "",
  },
  googleAnalytics: {
    key: "",
  },
};
